import React from 'react';
import { motion } from 'framer-motion';
import { Check, Salad, Zap, ShoppingCart, Users } from 'lucide-react';
export function WhatsIncluded() {
  return <section className="py-24 bg-cream" data-id="element-775">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-776">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-777">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-ink mb-6" data-id="element-778">
            Un sistema completo para transformar tu alimentación
          </h2>
          <p className="text-lg text-ink-light" data-id="element-779">
            No es un simple recetario. Es un sistema diseñado para ayudarte a
            comer mejor sin pensar qué cocinar todos los días.
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-premium border border-ink/5 mb-16 relative overflow-hidden" data-id="element-780">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-781" />
          <span className="inline-block px-4 py-1.5 bg-cream-dark text-ink font-bold text-sm rounded-full mb-8 tracking-wide" data-id="element-782">
            Incluido en los 3 kits
          </span>
          <div className="grid md:grid-cols-2 gap-6 relative z-10" data-id="element-783">
            {['+100 recetas saludables', 'Planificación semanal y mensual', 'Lista de compras para supermercado y dietética', 'Acceso inmediato y de por vida'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-784">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-combo-green/10 flex items-center justify-center mt-1" data-id="element-785">
                  <Check className="w-5 h-5 text-combo-green" data-id="element-786" />
                </div>
                <span className="text-lg font-medium text-ink" data-id="element-787">{item}</span>
              </div>)}
          </div>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-788">
          {[{
          icon: Salad,
          text: 'Resultados reales'
        }, {
          icon: Zap,
          text: 'Fáciles y rápidas'
        }, {
          icon: ShoppingCart,
          text: 'Ingredientes accesibles'
        }, {
          icon: Users,
          text: 'Pensado para la vida real'
        }].map((block, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-789">
              <div className="w-16 h-16 rounded-2xl bg-white shadow-sm border border-ink/5 flex items-center justify-center mb-4 text-gold" data-id="element-790">
                <block.icon className="w-8 h-8" data-id="element-791" />
              </div>
              <span className="font-medium text-ink" data-id="element-792">{block.text}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}